export function cleanupLocalStorage() {
    const keysToRemove: string[] = [];
  
    for (let i = 0; i < localStorage.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const key = localStorage.key(i)!;
  
      if (key.startsWith('Jodit'))
        keysToRemove.push(key);
    }
  
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
  
  export function setItem<T>(key: string, value: T): void {
    const valueJson = JSON.stringify(value);
    localStorage.setItem(key, valueJson);
  }
  
  export function getItem<T>(key: string): T | null;
  export function getItem<T>(key: string, defaultValue: T): T;
  export function getItem<T>(key: string, defaultValue?: T) {
    const item = localStorage.getItem(key);
  
    if (item === null)
      return defaultValue ?? null;
  
    try {
      return JSON.parse(item);
    }
    catch (ex) {
      // eslint-disable-next-line no-console
      console.error(`Error: getItem('${key}') failed because the value cannot be interpreted as a JSON token and there is no defaultValue to fall back to.`);
      if (defaultValue === undefined)
        throw ex;
  
      setItem(key, defaultValue); // self-heal
      return defaultValue;
    }
  }
  